import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../Components/Navbar/navbar";
import { useLocation, useNavigate } from "react-router";
import styles from "../Styles/tables.module.css";
import { Url, getUser } from "../../Constants/globals";
import { TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled } from "react-icons/tb";
import axios from "axios";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiTrash, HiSearch, HiX, HiBell } from "react-icons/hi";
import { HiOutlineNewspaper, HiOutlinePaperClip } from "react-icons/hi2";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";
import stylesModal from "../../Components/DeleteModal/deletemodal.module.css";
import Loading from "../../Components/Loading/loading";

function Modal({id, companies, closeModal, setAlert, setLoading, warningText, fetchData}) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);

  async function notify() {
    await setAlert("");
    await setLoading(<Loading/>);
    try {
      await axios.post(`${Url}/notify-news/${id}`, {}, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
      await fetchData();
      await setLoading("");
      await handleClose();
      return setAlert(<Alert type={"success"}>Utilizadores notificados com sucesso</Alert>)
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await notify();
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err);
        setLoading("");
        return  setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao notificar os utilizadores"}</Alert>);
      }
    };
  }

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      <div className={stylesModal.center}>
        <div className={stylesModal.column}>
          <h4 style={{margin:0}}>As seguintes empresas receberão notificação:</h4>
          <h4 style={{margin:0}}>{companies}</h4>
          {
            warningText ?
              <p style={{color: "red", fontSize: "11pt", marginTop: "10px"}}>{warningText}</p>
            :""
          }
          <div className={stylesModal.buttons}>
            <button className={stylesModal.actionButton} onClick={() => notify()}>{warningText ? "Notificar novamente" : "Notificar"}</button>
            <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

async function deleteNewsFunction(id){
  try {
    await axios.delete(`${Url}/news/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Eliminada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteNewsFunction(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar"}</Alert>];
    }
  };
}

async function getNews(page, search){
  try {
    const res = await axios.get(`${Url}/news?page=${page ? page : 1}${search ? "&search="+search : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getNews(page, search);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function ComunicacoesInternas({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [deleteNews, setDeleteNews] = useState("");
  const [notifModal, setNotifModal] = useState("");
  const [alert, setAlert] = useState("");
  const searchRef = useRef(null);
  const [loadingData, setLoadingData] = useState(true);
  const [newsData, setNewsData] = useState([]);
  const [previousPage, setPreviousPage] = useState("");
  const [nextPage, setNextPage] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(state?.page ? state.page : "");
  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");
  const [loading, setLoading] = useState("");

  async function assignData() {
    const thisNewsData = await getNews(currentPage);
    setCurrentPage(thisNewsData?.current_page);
    setNextPage(thisNewsData?.next_page);
    setPreviousPage(thisNewsData?.prev_page);
    setTotal(thisNewsData?.total_news);
    setPerPage(thisNewsData?.per_page);
    setNewsData(thisNewsData?.news);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function handlePageChange(next, start) {
    if (next) {
      const newNewsData = await getNews(start ? start : nextPage, nomeSearch);
      setNewsData(newNewsData.news);
      setCurrentPage(newNewsData.current_page);
      setNextPage(newNewsData.next_page);
      setPreviousPage(newNewsData.prev_page);
      setPerPage(newNewsData.per_page);
      setTotal(newNewsData.total_news);
    }
    else if (!next && previousPage) {
      const newNewsData = await getNews(previousPage, nomeSearch);
      setNewsData(newNewsData.news);
      setCurrentPage(newNewsData.current_page);
      setNextPage(newNewsData.next_page);
      setPreviousPage(newNewsData.prev_page);
      setPerPage(newNewsData.per_page);
      setTotal(newNewsData.total_news);
    }
    else {
      return;
    }
  }

  const handleSearchContainer = () => {
    if (showSearch){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShowSearch(false);
        setIsPoppedOut(false);
      },280);
    } else {
      setShowSearch(true);
      setTimeout(() => {
        searchRef.current.focus();
      }, 280);
    }
  }

  async function handleSearch(input) {
    if (input === false){
      setNomeSearch("");
    }
    const searchNewsData = await getNews(1, input === false ? "" : nomeSearch);
    setCurrentPage(searchNewsData.current_page);
    setNextPage(searchNewsData.next_page);
    setPreviousPage(searchNewsData.prev_page);
    setPerPage(searchNewsData.per_page);
    setNewsData(searchNewsData.news);
    setTotal(searchNewsData.total_news);
  }

  async function getAlertDelete(id) {
    if (id){
      await setAlert("");
      const res = await deleteNewsFunction(id);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  function getLastPage(){
    const calc = total / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  return (
    <div className="body">
      {loading}
      {alert}
      {deleteNews}
      {notifModal}
      <NavBar current={"comunicacoes-internas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={styles.btnAdd} onClick={() => navigate("/comunicacoes-internas/adicionar")}>
              <HiPlus size={20}/>
              <p className={styles.textAdd}>Adicionar</p>
            </button>
            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
          </div>
          <div className={styles.content}>
            {
              showSearch ?
                <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}  >
                  <input 
                    className={styles.searchInput}
                    ref={searchRef}
                    onChange={(e) => setNomeSearch(e.target.value)}
                    placeholder="Procurar por título"
                    value={nomeSearch}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") handleSearch();
                    }}
                  />
                  <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                    <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                    <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                  </div>
                </div>
              : ""
            }
            <div className={styles.table}>
              <div className={styles.newsColumn}>
                <p></p>
                <p>Título</p>
                <p>Direção</p>
                <p>Data de criação</p>
                <p>Criado por</p>
                <p>Ações</p>
              </div>
              <div className={styles.scrollContent}>
                {
                  newsData.length > 0 ?
                    newsData.map((object, index) =>
                      <div key={object.id} className={styles.newsInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                        <p title={object.is_news ? "Comunicação" : "Newsletter"} style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "3px"}}>
                          {object.is_news ? <HiOutlineNewspaper size={24}/> : <HiOutlinePaperClip size={24}/>}
                          <label className={styles.iconLabel}>{object.is_news ? "Comunicação" : "Newsletter"}</label>
                        </p>
                        <p title={object.title ? object.title : ""}>{object.title ? object.title : "-"}</p>
                        <p title={object.creator_name ? object.creator_name : ""}>{object.creator_name ? object.creator_name : "-"}</p>
                        <p title={object.created_at ? object.created_at : ""}>{object.created_at ? object.created_at : "-"}</p>
                        <p title={object.created_by ? object.created_by : ""}>{object.created_by ? object.created_by : "-"}</p>
                        <div className={styles.actions}>
                          <HiPencil onClick={() => navigate("/comunicacoes-internas/"+object.id, {state: {page: currentPage}})} className={styles.icon} size={22}/>
                          <HiTrash className={styles.icon} onClick={() => setDeleteNews(<DeleteModal close={setDeleteNews} objectId={object.id} objectName={object.title} deleteFunction={getAlertDelete}/>)} size={22}/>
                          <HiBell className={styles.icon} style={{opacity: object.notified ? 0.4 : ""}} title={"Notificar"} size={22} onClick={() => setNotifModal(<Modal id={object.id} companies={object.companies} closeModal={setNotifModal} setAlert={setAlert} setLoading={setLoading} warningText={object.notified ? `Esta ${object.is_news ? "comunicação" : "newsletter"} já foi notificada a ${object.notified}` : ""} fetchData={assignData} />)}/>
                        </div>
                      </div>
                    )
                  :
                    <div className={styles.noData}>
                      <p>Não existem dados</p>
                    </div>
                }
              </div>
              {
                previousPage || nextPage ?
                  <div className={styles.arrows}>
                    <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => handlePageChange(true, 1)}/>
                    <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                    {currentPage ? currentPage : ""}
                    <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                    <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => handlePageChange(true, getLastPage())}/>
                  </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default ComunicacoesInternas;
